window.App ||= {}

# Jquery Chosen select view for adding and removing items
# required options
# options : Array of possible values Objects
# selectedOptions : Array of values

# It's important to play with the valueProperty and descriptionProperty options
# an option like this
# {
# id: 33,
# name: 'Tomy',
# }
# would work with valueProperty = 'id'

class App.SelectView extends Backbone.View
  mainTemplate: JST["backbone/templates/monitoring/select/main"]
  multipleTemplate: JST["backbone/templates/monitoring/select/select_multiple"]
  labelTemplate: JST['backbone/templates/monitoring/select/select_label']
  className: 'select-view'

  events:
    'click .showmore':'onShowMore'
    'click .showless':'onShowLess'
    'click .clear-icon': 'clearChosenInput'

  defaults:
    selectedOptions: []
    fixedOptions: []
    valueProperty: 'value' # option[valueProperty]
    descriptionProperty: 'name' # option[descriptionProperty]
    width: '200px'
    editable: true
    placeholder: 'Select an item'
    disabledPlaceholder: 'Disabled'
    selectName: undefined # adds a name to the select for sending the form
    multiple: false
    showTags: true # indicates if tags should be shown. Used for more complex uses like HierarchicalSelectView
    clearableInput: false


  initialize: (@options = {}) ->
    _.defaults(@options, @defaults) #set defaults
    _.extend(@, @options) #extends this with defaults
    @customLabelClass = ''
    @render()

  render: ->
    template = if @multiple then @multipleTemplate else @mainTemplate
    @$el.html(template(view:@))
    @setEditable(@editable)
    @$tags = @$el.find('.tags')
    @$select = @$el.find('select')
    @$select.attr('name', @selectName) if @selectName
    @$select.prop('title', @placeholder) if @placeholder.length > 28
    @addOption(option) for option in @options
    @addFixedOptions()
    @$select.chosen(@chosenOptions())
    @_addClearInputButton() if @clearableInput
    @$select.on('change', @onSelect)

  changePlaceholder: (text) ->
    @$el.find('.chosen-single span').text(text)

  onShowMore: ->
    @trigger('showmore')

  onShowLess: ->
    @trigger('showless')

  # To add extra elements that are not in the selectable list. Note that these elements could be removed, but couln't be added again
  addFixedOptions: ->
    return if _.isEmpty(@fixedOptions)

    for option in @fixedOptions
      optionEl = document.createElement('option')
      optionEl.realValue = option
      optionEl.setAttribute('value', option)
      $(optionEl).text(option)
      @$select.append(optionEl)
      optionEl.disabled = true
      @addLabel(optionEl)

  chosenOptions: ->
    width: @width,
    placeholder_text: @placeholder,
    allow_single_deselect: true,
    search_contains: true

  setEditable: (editable) ->
    @$el.toggleClass('non-editable', !editable) # it's easier to disable things trough css this way

  addOption: (option, container=@$select) -> # used to generate all the options
    val = option[@valueProperty]
    des = option[@descriptionProperty]
    optionEl = document.createElement('option')
    optionEl.className = @_optionClass(option) || '' # adding a class to the options
    optionEl.realValue = val # store the real value to obtain, so we do not lose the type
    optionEl.setAttribute('value', val)
    $(optionEl).text(des)
    container.append(optionEl)
    if _.contains(@selectedOptions, val)
      optionEl.disabled = true
      @addLabel(optionEl)

  _optionClass: (_option) ->
    @title.toLowerCase() if @title

  selectByText: (text) ->
    selected = _.find @$select.find('option'), (option) -> $(option).text() == text
    if selected?
      selected = $(selected)
      selected.attr('disabled', true)
      @$select.trigger('chosen:updated')
      @addLabel(selected.eq(0))

  toArray: ->
    _.collect(@_getSelected(), (el) ->
      el.realValue
    )

  toDescriptionArray: ->
    _.collect(@_getSelected(), (el) ->
      $(el).text()
    )

  toObjectArray: ->
    _.collect(@_getSelected(), (el) =>
      obj = {}
      obj[@valueProperty] = el.realValue
      obj[@descriptionProperty] = el.text
      obj
    )

  _getSelected: ->
    # we are storing disabled options as selected
    @$select.find('[disabled]').not('[value=""]')

  onSelect: =>
    selected = @$select.find(':selected')
    selected.prop('selected', false).attr('disabled', true)
    @$select.trigger 'chosen:updated'
    selected.each (_, element) => @addLabel(element)
    @trigger('change', $(selected.eq(0)))

  addLabel: (option) =>
    label = $(@_labelTemplate(option))
    label.get(0).linkedSelect = option
    span = label.children().eq(1)
    text = $(option).text()
    span.text(text)
    span.prop('title', text)
    label.children().eq(0).click(@onRemove)
    @$tags.append(label)

  _labelTemplate: (_option) ->
    hiddenClass = if @showTags then '' else 'hidden'
    labelClass = "#{@customLabelClass} #{hiddenClass}"
    @labelTemplate(labelClass: labelClass)

  onRemove: (event) =>
    selected = $(event.currentTarget)
    select = selected.parent().get(0).linkedSelect
    selected.parent().detach()
    @_reactivateOption(select)
    @$select.trigger('chosen:updated')
    @trigger('change')

  setLabelCustomClass: (className) =>
    @customLabelClass = className.toLowerCase()

  clean: ->
    _.collect(@$tags.children(), (el) => @onRemove({currentTarget: $(el).children()}))

  selectAll: =>
    @$el.find("option[value != '']:not(:disabled)").prop("selected", true)
    @onSelect()

  _reactivateOption: (element) =>
    $(element).attr('disabled', false)

  clearChosenInput: =>
    @userInput = ''
    @_setChosenInput()
    @$select.trigger('chosen:updated')

  _addClearInputButton: ->
    @$chosenInput = @$el.find('input.chosen-search-input')
    @$chosenInput.addClass('default-text')
    @$chosenInput.before('<i class="fa fa-close clear-icon disabled"></i>')
    @$chosenInput.on('input', @_onChosenInputChange)
    @$chosenInput.on('blur', @_setChosenInput)
    @$chosenInput.on('focusin', @_setChosenInput)

  _onChosenInputChange: =>
    @$el.find('.clear-icon').toggleClass('disabled', !@$chosenInput.val())
    @userInput = @$chosenInput.val()

  _setChosenInput: =>
    @$chosenInput.val(@userInput) if @userInput
    @_triggerInputLengthAdjustment()
    @$chosenInput.toggleClass('default-text', !@userInput)

  _triggerInputLengthAdjustment: ->
    @$chosenInput.keydown()

  disable: =>
    @_toggleDisabled(true)

  enable: =>
    @_toggleDisabled(false)

  _toggleDisabled: (isDisabled) ->
    @$select.prop('disabled', isDisabled).trigger('chosen:updated')
    @$tags.find('.label').toggleClass('disabled', isDisabled)
    @changePlaceholder(if isDisabled then @disabledPlaceholder else @placeholder)


class App.APESelectView extends App.SelectView
  render: ->
    template = if @multiple then @multipleTemplate else @mainTemplate
    @$el.html(template(view:@))
    @setEditable(@editable)
    @$tags = @$el.find('.tags')
    @$select = @$el.find('select')
    @$select.attr('name', @selectName) if @selectName
    @addOption(option) for option in @options
    @addFixedOptions()
    @addSelectedOptions()
    @$select.chosen(@chosenOptions())
    @$select.on('change', @onSelect)

  addSelectedOptions: ->
    return if _.isEmpty(@selectedOptions)

    for selectedOption in @selectedOptions
      valId = selectedOption[@valueProperty]
      name = selectedOption[@descriptionProperty]
      optionEl = document.createElement('option')
      optionEl.className = @title.toLowerCase() if @title
      optionEl.realValue = valId
      optionEl.setAttribute('value', valId)
      $(optionEl).text(name)
      optionEl.disabled = true
      @addLabel(optionEl)

  addOption: (option, container=@$select) -> # used to generate all the options
    val = option[@valueProperty]
    des = option[@descriptionProperty]
    optionEl = document.createElement('option')
    optionEl.className = @title.toLowerCase() if @title # adding a class to the options
    optionEl.realValue = val # store the real value to obtain, so we do not lose the type
    optionEl.setAttribute('value', val)
    $(optionEl).text(des)
    selectedOptionsIds = _.collect(@selectedOptions, (el) -> el.id )
    if _.contains(selectedOptionsIds, val)
      optionEl.disabled = true
    container.append(optionEl)

  addLabel: (option)->
    # icon goes first beacuse it has 'float: right'
    hideStyle = if @showTags then '' else "style='display:none'"
    label = $("<span #{hideStyle} class='label #{@customLabelClass}' value='#{$(option).val()}'><i class='icon-white icon-remove'></i><span></span></span>")
    label.get(0).linkedSelect = option
    span = label.children().eq(1)
    text = $(option).text()
    span.text(text)
    span.prop('title', text)
    label.children().eq(0).click(@onRemove)
    @$tags.append(label)

  _getSelected: ->
    @$tags.find('.label')

  toObjectArray: ->
    tags = @$tags.find('.label')
    _.collect(tags, (elem) ->
      idValue = $(elem).attr("value")
      name = elem.textContent.replace(" ("+idValue+")", "")
      obj = { id: idValue, label: elem.textContent, name: name }
      obj
    )

class App.AllSelectByProviderView extends App.SelectView
  template: JST["backbone/templates/monitoring/select/select_multiple"]

  initialize: (@options = {}) ->
    @sourceIconModel = new Monitoring.Models.SourceIcon
    types = [{id: 'all', name: I18n.t('monitoring.dashboard.topic_modal.all')}] # default tied to topics
    types = types.concat(@options.options)
    @options.options = types
    super

  render: ->
    @$el.html(@template(view:@))
    @setEditable(@editable)
    @$tags = @$el.find('.tags')
    @$select = @$el.find('select')
    @$select.attr('name', @selectName) if @selectName
    @addOptionsGroupedByProviders(@getTopicsByProviders(@options))
    @addFixedOptions()
    @$select.chosen(@chosenOptions())
    @$select.on('change', @onSelect)

  getTopicsByProviders:(topics) ->
    topicsByProvider = @buildSortedProviderKeys()
    _.each(topics, (topic) =>
      if topic.id in ["all-active-topics","all-own-active-topics","all-own-topics","all-listening-active-topics","all-listening-topics", "all"]
        topicsByProvider[''].push(topic)
      else
        provider = @sourceIconModel.sourcePrettyName(topic.sources)
        topicsByProvider[provider].push(topic)
    )
    @sortTopicsInsideProvider(topicsByProvider)

  sortTopicsInsideProvider: (topicsByProvider) ->
    sortedTopicsByProvider = {}
    for provider, topics of topicsByProvider
      sortedTopicsByProvider[provider] = _.sortBy(topics, (topic) => topic.name.toLowerCase())
    sortedTopicsByProvider

  buildSortedProviderKeys: ->
    emptyByProviders = {}
    list = @sourceIconModel.sortedProviderNames()
    _.each(list, (provider) =>
      emptyByProviders[provider] = []
    )
    emptyByProviders['other'] = []
    emptyByProviders

  addOptionsGroupedByProviders:(topicsByProviders) ->
    for provider, topics of topicsByProviders
      optgroup = @addProviderSeparatorTag(provider)
      _.each(topics, (topic) =>
        val = topic[@valueProperty]
        des = topic[@descriptionProperty]
        topicSource = topic.sources
        classname = {
          'all': !provider,
          'own': !!topic.owned,
          'allowListening':  !!topic.allow_listening
          'listening': !!topic.listening
        }
        classList = Object.keys(classname).filter((x) -> classname[x])
        optionEl = @buildOptionElement(val, des, topicSource, classList)
        for cssClass in classList
          optgroup[0].classList.add(cssClass)
        optgroup.append(optionEl)
        if _.contains(@selectedOptions, val)
          optionEl.disabled = true
          @addLabel(optionEl)
      )
      @$select.append(optgroup)

  addProviderSeparatorTag: (provider) ->
    if provider == "other"
      translation = I18n.t('monitoring.dashboard.topic_modal.other_topics')
      provider = translation.split(" ").join("&nbsp;")
    optgroup = $("<optgroup label=#{provider}>")

  buildOptionElement: (val, des, topicSource, classList) ->
    optionEl = document.createElement('option')
    optionEl.classList.add(I18n.locale)
    for cssClass in classList
      optionEl.classList.add(cssClass)
    icon = @iconClassForTopicSource(topicSource)
    optionEl.classList.add(icon) if icon
    optionEl.realValue = val # store the real value to obtain, so we do not lose the type
    optionEl.setAttribute('value', val)
    $(optionEl).text(des)
    optionEl

  iconClassForTopicSource: (topicSource) ->
    @sourceIconModel.sourceIcon(topicSource) 

  addLabel: (option)->
    # icon goes first beacuse it has 'float: right'
    hideStyle = if @showTags then '' else "style='display:none'"
    iconClass = option.classList
    label = $("<span #{hideStyle} class='#{iconClass}-white label #{@customLabelClass}' value='#{$(option).val()}'><i class='icon-white icon-remove'></i><span></span></span>")
    label.get(0).linkedSelect = option
    span = label.children().eq(1)
    text = $(option).text()
    span.text(text)
    span.prop('title', text)
    label.children().eq(0).click(@onRemove)
    @$tags.append(label)

  onSelect: =>
    return super unless (selected = @$select.find(':selected')).val() == 'all'
    selected.prop 'selected', false
    @$select.find('option').not('[value=""]').attr 'disabled', true
    @$tags.find('.label').detach()
    @$select.trigger 'chosen:updated'
    @addLabel @$select.find('option[value="all"]').eq(0)
    @trigger 'change'

  _reactivateOption: (element) =>
    return super unless $(element).val() == 'all'
    @$select.find('option').not('[value=""]').attr 'disabled', false

  _getSelected: ->
    return super unless (options = @$select.find('option')).filter('[value="all"]').attr('disabled')
    options.not('[value="all"]').not('[value=""]')

class App.AllSelectView extends App.SelectView
  initialize: (@options = {}) ->
    @editable = @options.editable if @options.editable?
    types = [@_allOption()]
    types = types.concat(@options.options)
    @options.options = types
    super

  _allOption: ->
    {id: 'all', name: 'All'}

  onSelect: =>
    return super unless (selected = @$select.find(':selected')).val() == 'all'
    selected.prop 'selected', false
    @$select.find('option').not('[value=""]').attr 'disabled', true
    @$tags.find('.label').detach()
    @$select.trigger 'chosen:updated'
    @addLabel @$select.find('option[value="all"]').eq(0)
    @trigger 'change'

  _reactivateOption: (element) =>
    return super unless $(element).val() == 'all'
    @$select.find('option').not('[value=""]').attr 'disabled', false

  _getSelected: ->
    return super unless (options = @$select.find('option')).filter('[value="all"]').attr('disabled')
    options.not('[value="all"]').not('[value=""]')

# Option Format
#  {
#    id: 33,
#    name: 'Tomy',
#    optionClass: 'unassigned-icon'
#  }
class App.SelectWithIconsView extends App.SelectView
  _allOption: ->
    {
      id: 'all'
      name: I18n.t('common.select.all')
      optionClass: @options.allOptionsClass
    }

  _optionClass: (option) ->
    option['optionClass']

  _labelTemplate: (option) ->
    optionClass = option.className || ''
    labelClass = "#{optionClass} with-icon"
    @labelTemplate(labelClass: labelClass)

class App.AttributesSelectView extends App.SelectView

  initialize: (@options = {}) ->
    @clonedAttributes = _.clone(@options.attributeOptions)
    #
    # like http://api.rubyonrails.org/classes/ActiveRecord/NestedAttributes/ClassMethods.html#module-ActiveRecord::NestedAttributes::ClassMethods-label-One-to-many
    # [{
    # id: 1,
    # tag: 'example_tag'
    # }]
    #
    @options.attributeValueProperty # tag in this example
    @options.selectedOptions = _.collect(@clonedAttributes, (e) =>
      e[@options.attributeValueProperty]
    )
    super

  toAttributes: ->
    attributes = []
    prop = @attributeValueProperty
    clon = @clonedAttributes
    initialOptions = @selectedOptions
    actualOptions = @toArray()
    notModified = _.intersection(initialOptions, actualOptions)
    destroyedOptions = _.difference(initialOptions, notModified)
    newOptions = _.difference(actualOptions, notModified)
    _.each newOptions, (option) ->
      res = {}
      res[prop] = option
      attributes.push(res)
    _.each destroyedOptions, (option) ->
      res = {}
      res['_destroy'] = true
      res['id'] = _.find(clon, (e)->
        e[prop] == option
      ).id
      attributes.push(res)
    attributes

  allAttributes: ->
    attributes = []
    prop = @attributeValueProperty
    clon = @clonedAttributes
    initialOptions = @selectedOptions
    actualOptions = @toArray()
    notModified = _.intersection(initialOptions, actualOptions)
    destroyedOptions = _.difference(initialOptions, notModified)
    newOptions = _.difference(actualOptions, notModified)
    _.each newOptions, (option) ->
      res = {}
      res[prop] = option
      attributes.push(res)
    _.each destroyedOptions, (option) ->
      res = {}
      res['_destroy'] = true
      res['id'] = _.find(clon, (e)->
        e[prop] == option
      ).id
      attributes.push(res)
    _.each notModified, (option) ->
      res = {}
      res['_no_action'] = true
      res['id'] = _.find(clon, (e)->
        e[prop] == option
      ).id
      attributes.push(res)
    attributes

# i.e:
#
#  options: [
#    {
#      title: 'Groups',
#      options: { options: @users_groups, valueProperty: 'id', descriptionProperty: 'name'}
#    },
#    {
#      title: 'Users',
#      options: { options: @users, valueProperty: 'id', descriptionProperty: 'description'}
#    }
#  ]
class App.GroupSelectView extends App.SelectView

  # used to generate all the options inside the optgroup with a title
  addOption: (option) ->
    _.defaults(option['options'], @defaults) #set defaults
    _.extend(@, option['options']) #extends this with defaults

    title = option['title']
    options = option['options']

    optionGroupClass = if title then title.toLowerCase().replace(/ /g, '-') else ''
    @$select.append("<optgroup label='#{title}' class='optgroup-#{optionGroupClass}'></optgroup>")
    @$optgroup = @$select.find(".optgroup-#{optionGroupClass}")

    if title
      super(option, @$optgroup) for option in options['options']
    else
      super(option) for option in options['options']

  selected: ->
    @$el.find('[disabled]')

  selectedWithClass: (cssClass) ->
    selectedValues = @selected().filter(".#{cssClass}").map(-> @realValue).get()
    @_excludeSpecialValuesFrom selectedValues

  _excludeSpecialValuesFrom: (ids) ->
    # Excludes string values such as 'me' and 'robot' from selected ids; accepts numeric ids and empty string (nobody)
    (id for id in ids when isFinite id)

  myselfIsSelected: ->
    'me' in @toArray()

  robotIsSelected: ->
    'robot' in @toArray()

  selectedHasClass: (klass) ->
    if @selected() then @selected().hasClass(klass) else false


class App.UniqueSelectView extends App.SelectView

  chosenOptions: ->
    width: @width,
    placeholder_text: @placeholder,
    allow_single_deselect: true,
    search_contains: true,
    max_selected_options: 1

  onSelect: =>
    selected = @$select.find(":selected")
    selected.prop("selected", false) # unselect because it's non multiple
    if @_getSelected().length > 0
      swal('Limit error', "Can't add more than one", 'error')
    else
      selected.attr('disabled', true)
      @addLabel(selected.eq(0))
      @trigger('change')
    @$select.trigger('chosen:updated')

class App.LonelyOptionSelectView extends App.SelectView

  initialize: (@options = {}) ->
    @editable = @options.editable if @options.editable?
    @lonelyOption = @options.lonely
    types = [@lonelyOption].concat(@options.options)
    @options.options = types
    super

  onSelect: =>
    selected = @$select.find(':selected')
    selected.prop('selected', false)
    if @selectionConflict(selected.val())
      @trigger('selection:lonely:error')
    else
      selected.attr('disabled', true)
      @addLabel(selected.eq(0))
      @trigger('change')
    @$select.trigger('chosen:updated')

  selectionConflict: (selectedValue) =>
    selectedArray = @_getSelected()
    return true if selectedValue.toString() == @lonelyOption[@valueProperty].toString() && selectedArray.length > 0
    return true if selectedArray.length == 1 && selectedArray[0].realValue.toString() == @lonelyOption[@valueProperty].toString()
    false

class App.SubTypeSelectView extends App.GroupSelectView

  addLabel: (option) =>
    label = $(@_labelTemplate(option))
    label.get(0).linkedSelect = option
    span = label.children().eq(1)
    text = @getLabel(option.value)
    span.text(text)
    span.prop('title', text)
    label.children().eq(0).click(@onRemove)
    @$tags.append(label)

  getLabel: (text) ->
    @translator ||= new Customer.Filters.SubTypeTranslator()
    return _.str.capitalize(@translator.getTranslation(text))
